import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { HomeComponent } from './home.component';
import { CustomerComponent } from './customer/customer.component';
import { ServicesHomeComponent } from './services/services.component';
import { SliderComponent } from './slider/slider.component';
import { CoreModule } from '../share/core.module';
import { PricingComponent } from './pricing/pricing.component';


const routes: Routes = [
  { path: "", component: HomeComponent },
]

@NgModule({
  declarations: [
    HomeComponent,
    CustomerComponent,
    ServicesHomeComponent,
    SliderComponent,
    PricingComponent
  ],
  imports: [
    RouterModule.forChild(routes),
    CoreModule
  ],
  exports: [
    RouterModule
  ]
})
export class HomeModule { }

